import React from 'react'
import DataTable, { TableAction, TableColumn } from '../../../shared/components/DataTable'
import { ICarModel } from './CarModel'

type Props = {
  data: ICarModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  onPageSizeChange?: (pageSize: number) => void
  onPageChange: (page: number) => void  
  onEdit?: (car: ICarModel) => void  
  onDelete?: (car: ICarModel) => void 
  sortBy?: string  
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const CarStatusTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const columns: TableColumn<ICarModel>[] = [
    { key: 'startDate', label: 'Baş. Zaman', className: 'fw-semibold', sortable: true },
    { key: 'endDate', label: 'Bit. Zaman', className: 'fw-semibold', sortable: true },
    { key: 'vehicleGroupName', label: 'Araç Grubu' },
    { key: 'carPlate', label: 'Plaka', sortable: true },
    { key: 'brandName', label: 'Marka' },
    { key: 'modelType', label: 'Tipi' },
    { key: 'fuelType', label: 'Yakıt Tipi' },
    { key: 'transmission', label: 'Vites Tipi' },
    { key: 'customerFullName', label: 'Adı Soyadı' },
  ]

  const actions: TableAction<ICarModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (item) => onEdit?.(item),  
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (item) => onDelete?.(item), 
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange} 
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Araç bulunamadı.'
    />
  )
}